import { Component, Input, OnInit, OnDestroy, ViewChild, Output, EventEmitter, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonBeatsDialogComponent } from '../popups/common-beat-popups/common-beats-dialog.component';
import { BeatListModel } from '../../../models/beat-list-model';
import { BeatsService } from 'src/app/services/beats-service/beats.service';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';
import { FavoriteService } from 'src/app/services/favorite/favorite.service';
import { PlayerService } from 'src/app/services/music-player/player.service';
import { LicenseSlug } from 'src/app/models/selected-files-data';
import { CouponService } from 'src/app/services/coupon/coupon.service';
import { CouponListModel } from 'src/app/models/coupon-list';
import { UserDetails } from 'src/app/models/user-details.model';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { FormsService } from 'src/app/services/Forms/forms.service';
import { UserService } from 'src/app/services/user-service/user.service';
import { Ga4trackingService } from 'src/app/services/ga4Tracking/ga4tracking.service';
import { SoundKitListModel } from 'src/app/models/sound-kit-list.model';
import { SoundUploadRoutingModule } from 'src/app/lazy-load-modules/producer-lazy-modules/sound-upload/sound-upload-routing.module';
import { CampaignService } from 'src/app/services/campaign/campaign.service';

@Component({
  selector: 'ipm-beats',
  templateUrl: './beats.component.html',
  styleUrls: ['./beats.component.scss']
})
export class BeatsComponent implements OnInit, OnDestroy {
  viewType: string = "list";
  @Input() isTabView: boolean = false;
  @Input() beatsList: Array<BeatListModel> = [];
  @Input() soundKitsList: Array<SoundKitListModel> = [];
  @Input() beatObject: BeatListModel;
  @Input() soundObject: SoundKitListModel;
  @Input() currentBeatsDetails: BeatListModel;
  @Input() isPublic: boolean =  true;
  @Input() dataType: string = "array";
  @Input() componentType: string = "";
  @Input() isShowFullArtist: boolean = false;
  @Input() renderType: string = "";
  @Input() isProKit: boolean = false;
  @Input() forceViewType?: string; // Flag to indicate if rendering Pro Kits
  @Output() onchangeFavList: EventEmitter<any> = new EventEmitter();
  @Output() onchangeData: EventEmitter<any> = new EventEmitter();
  @ViewChild('commonSharedCop') sharedDialog : CommonBeatsDialogComponent;
  @ViewChild('loginAlertUserPopup', { static: false }) loginAlertUserPopup: TemplateRef<any>;
  @ViewChild( 'appliedCoupon', {static: false}) appliedTemplate : TemplateRef<any>;
  @ViewChild('negotiationTemplate', {static :  false}) negotiationTemplate : TemplateRef<any>;
  @ViewChild('fullNameUpdateTemplate', {static :  false}) fullNameUpdateTemplate : TemplateRef<any>;
  @ViewChild('adPopupTemplate', { static: false }) adPopupTemplate: TemplateRef<any>;
  selectedCoupon: any = "";
  currentUserDetails: UserDetails;
  currentPlayBeatData: BeatListModel;
  fullName: any = "";
  currentCreditBalance: number = 0;
  private impressionTracked = new Set<string>();
  private impressionIntervals = new Map<string, ReturnType<typeof setInterval>>();
  private readonly IMPRESSION_INTERVAL_MS = 7 * 60 * 1000;
  currentAdBeat: BeatListModel | null = null;

  /**
   * Ad ("Boosted Beat") info popup: only from the AD icon next to the title, never when a beat is played.
   * Stops propagation so the card click (play) does not also fire.
   */
  toggleAdPopup(event: Event, beat: BeatListModel): void {
    event.stopPropagation();
    this.currentAdBeat = beat;
    const className = this.commonService.getClassName('ipm-ad-info-dialog');
    this.commonService.openModel(this.adPopupTemplate, null, className);
  }

  get isSoundKit(): boolean {
    return this.renderType === 'soundKit' || this.renderType === 'artistSoundList';
  }

  constructor(private router: Router,
    private beatService: BeatsService,
    public commonService: CommonService,
    private browserStorageService: BrowserStorageService,
    private favoriteService: FavoriteService,
    private playerService: PlayerService,
    private activatedRoute: ActivatedRoute,
    private couponService: CouponService,
    private authService: AuthService,
    public ga4Tracking: Ga4trackingService,
    public formService: FormsService,
    private userService: UserService,
  private compgainService: CampaignService) {
      this.commonService.updatePlayPauseStatus.next("");
      this.authService.currentUserDetails.subscribe((userObj: UserDetails)  => {
        if (userObj &&  Object.keys(userObj).length > 0) {
          this.currentUserDetails = userObj;
          this.currentUserDetails.email
        }
      })
    }

  ngOnInit(): void {
    this.beatService.isUpdateData.subscribe( (beatObj: BeatListModel) => {
      this.onchangeData.emit(beatObj);
      this.currentPlayBeatData = beatObj;
      this.beatsList.filter( (beatData: BeatListModel) => {
          if ( beatData._id ===  beatObj._id) {
            beatData.isPlayMusic = beatObj.isPlayMusic;
            beatData.isBeatPlayed = true;
          } else {
            beatData.isPlayMusic = false;
            beatData.isBeatPlayed = false;
          }
          return beatData;
      });
      if (this.beatObject &&  Object.keys(this.beatObject).length > 0) {
        if ( this.beatObject?._id  === beatObj?._id) {
          this.beatObject.isPlayMusic = beatObj.isPlayMusic;
          this.beatObject.isBeatPlayed = true;
        } else {
          this.beatObject.isPlayMusic = false;
          this.beatObject.isBeatPlayed = false;
        }
      }
    });
    if (this.forceViewType) {
      this.viewType = this.forceViewType;
    } else if (this.dataType === "object" || this.dataType === "findData") {
      this.viewType = "grid";
    } else if ( this.renderType ===  'soundKit' || this.renderType ===  'artistSoundList') {
      this.viewType = "grid";
    } else {
      this.commonService.beatView.subscribe( view => {
        this.viewType = view;
      });
    }

    this.commonService.updatePlayPauseStatus.subscribe((res:any) => {
      if (res) {
        this.playBeat(res);
      }
    });
     this.commonService.currentCreditBalanceChanges.subscribe((res) => {
      this.currentCreditBalance = res;
    });
  }

  isSoundFree(soundKit: any): boolean {
  // Check if it's free via regular price
  const isFreeViaPrice = soundKit.price?.final_price === 0;
  
  return isFreeViaPrice && !this.isProKit;
}
  /**
   * in this function open beat price dialog box
   * @param beatObj
   * @param selectedSlug
   */
  priceDialog(beatObj: BeatListModel, selectedSlug: string = "") {
    let selectedLicSlug: any = selectedSlug;
    
    // Track analytics based on renderType
    let eventname = this.renderType === 'soundKit' || this.renderType === 'artistSoundList' 
      ? `license_popup_sound_${('creditPrice' in beatObj && beatObj.creditPrice) ? `credit_${beatObj.creditPrice}` : (this.isSoundFree(beatObj)) ? `free` : 'buy'}`
      : 'licens_pop_up_beats';
    let attributes: any = {
      category: this.renderType === 'soundKit' ? 'Sound' : 'Beats',
      label: this.renderType === 'soundKit' ? 'soundKits' : 'button',
      action: 'click',
      userRole: this.currentUserDetails?.role || 'guest',
      userId : this.currentUserDetails?._id || 'guest'
    };
    this.ga4Tracking.sendEvent(eventname, attributes);

    if (this.activatedRoute.snapshot.queryParams['beats_with_exclusives']) {
      selectedLicSlug = LicenseSlug.Exclusive;
    } else if (this.activatedRoute.snapshot.queryParams['wav_stems_1999']) {
      selectedLicSlug = LicenseSlug.WavStem;
    } else if (this.activatedRoute.snapshot.queryParams['wav_under_999']) {
      selectedLicSlug = LicenseSlug.Wav;
    }
    
    // Pass renderType to dialog so it knows which popup to show
    this.sharedDialog.openPriceDialog(beatObj as BeatListModel, selectedLicSlug, 'negotiation', this.renderType);
  }

  /**
   * In this function open share dialog box
   * @param params
   * @param type
   */
  shareBeatDialog(params: any, type: string = "") {
    let eventname = 'share_sound' 
    let attributes: any = {
      category: 'sound',
      label: 'soundKits',
      action: 'click',
      userRole: this.currentUserDetails?.role || 'guest',
      userId : this.currentUserDetails?._id || 'guest',
    }
    this.ga4Tracking.sendEvent(eventname, attributes);
    let link = ";"
    if (!type || type === "beat") {
      link = `bt-${params}`;
    } else if (type === "soundKit" || type === "artistSoundList") {
      link = `sk-${params}`;
    } else if (type === "playlist") {
      link = `playlist/${params}`;
    } else {
      link = `${params}`;
    }
    this.sharedDialog.openShareDialog(link, type);
  }

  /**
   * In this function route to
   * the beat details
   * @param beatId
   * @param beat
   */
  navigateBeatDetails(beatId: number, beat?: any) {
    let event = this.renderType === "soundKit"  || this.renderType === "artistSoundList" ? 'click_sound_kit_title': 'click_beat_title';
    let attributes: any = {
      category: this.renderType === "soundKit" ? 'SoundKits': 'Beats',
      label: 'button',
      action: 'click',
      userRole: this.currentUserDetails?.role || 'guest',
      userId : this.currentUserDetails?._id || 'guest'
    }
    this.ga4Tracking.sendEvent(event, attributes);

    if (beat?.is_ad && this.renderType !== 'artistProfile') {
      this.compgainService.trackClick(beat).subscribe();
    }

    let routingUrl = "/bt-"+beatId;
    if (this.renderType === "soundKit" || this.renderType === "artistSoundList") {
      routingUrl = "/sk-"+beatId
    }
    this.router.navigate([routingUrl]);

  }

  /**
   * in this function pay current beat
   * @param beatObj
   */
  playBeat(beatObj: BeatListModel) {
    if(beatObj?.is_ad){
      let eventName = 'play_beat_ad';
      let attributes = {
        category:'Beats',
        label: 'button',
        action: 'click',
        userRole: this.currentUserDetails?.role || 'guest',
        Genre: beatObj?.genre,
        tempo: beatObj?.tempo
      }
      this.ga4Tracking.sendEvent(eventName, attributes);

    }
    if (beatObj && beatObj.preview) {

      if (this.currentPlayBeatData &&  this.currentPlayBeatData._id === beatObj._id) {
        let  newPlayState = !beatObj?.isPlayMusic ;
        const isSoundKit = this.isSoundKit;
        let eventname = newPlayState
          ? (isSoundKit ? 'play_sound' : 'play_beat')
          : (isSoundKit ? 'pause_sound' : 'pause_beat');
         let attributes: any = {
          category: 'Beats',
          label: 'button',
          action: 'click',
          userRole: this.currentUserDetails?.role || 'guest',
          Genre: beatObj?.genre,
         Tempo: beatObj?.tempo
      };
      if (Array.isArray(beatObj?.mood)) {
        beatObj.mood.forEach((mood: string, index: number) => {
          attributes[`mood${index + 1}`] = mood;
        });
      }

      // Continue with remaining attributes
      attributes.beatId = beatObj._id;
      attributes.beatName = beatObj.title;
      attributes.userId = this.currentUserDetails?._id || 'guest';

      this.ga4Tracking.sendEvent(eventname, attributes);

      this.playerService.isCurrentPlayChangeState();
      this.beatsList.filter(( beatData: BeatListModel ) => {
        if (beatData._id === this.currentPlayBeatData._id) {
          beatData.isPlayMusic = !beatData.isPlayMusic;
          if (beatData.isPlayMusic && beatData?.is_ad && this.renderType !== "artistProfile" && !isSoundKit) {
            this.compgainService.trackPlay(beatData).subscribe();
          }
        }
        return  beatData;
      });
      
        // this.beatService.currentPlayBeat.next(beatObj);
      }  else {
        const eventname = 'play_beat';
        let attributes: any = {
          category: 'Beats',
          label: 'button',
          action: 'click',
          userRole: this.currentUserDetails?.role || 'guest',
          Genre: beatObj?.genre,
          Tempo: beatObj?.tempo
        };

        // Insert mood1, mood2, ... after Tempo
        if (Array.isArray(beatObj?.mood)) {
          beatObj.mood.forEach((mood: string, index: number) => {
            attributes[`mood${index + 1}`] = mood;
          });
        }

        // Continue with remaining attributes
        attributes.beatId = beatObj._id;
        attributes.beatName = beatObj.title;
        attributes.userId = this.currentUserDetails?._id || 'guest';
      this.ga4Tracking.sendEvent(eventname, attributes);
        let  beatList: Array<BeatListModel> =  JSON.parse(JSON.stringify(this.beatsList));
        if (this.currentBeatsDetails &&  this.currentBeatsDetails._id === beatObj._id) {
          beatList.push(this.currentBeatsDetails);
        }
        this.beatService.playerBeatsList.next(beatList);
        this.beatService.currentPlayBeat.next(beatObj);
        this.beatService.isMusicPlayOpen.next(true);
      }
    }
  }

  /**
   * In this function route to artist profile
   * @param profileHandle
   */
  goToArtistProfile(beatObj: any) {
    this.commonService.goToArtistProfile(beatObj?.created_by?.handle);
    const isSoundKit = this.isSoundKit;
    let event = isSoundKit ? 'click_sound_producer' : 'click_beat_producer';
    let attributes: any = {
      category: 'Beats',
      label: 'Engagement',
      action: 'click',
      userRole: this.currentUserDetails?.role || 'guest',
      userId : this.currentUserDetails?._id || 'guest'
    }
    if (beatObj?.is_ad && !isSoundKit && this.renderType !== 'artistProfile') {
      this.compgainService.trackClick(beatObj).subscribe();
      this.compgainService.trackProducerProfileClick(beatObj,beatObj.created_by?._id).subscribe();
    }
    this.ga4Tracking.sendEvent(event, attributes);
  }


  /**
   * in this function open download dialog box
   * @param beatObject
   */
  downloadMp3(beatObject: BeatListModel) {
    let data: any =  this.browserStorageService.getSessionData();
    let eventname = 'dialog_free_mp3_download';
    let attributes: any = {
      category: 'Beats',
      label: 'button',
      action: 'click',
      userRole: this.currentUserDetails?.role || 'guest',
      userId : this.currentUserDetails?._id || 'guest',
      beatName : beatObject?.title,
      beatId : beatObject?._id ,
      Genre : beatObject?.genre
    }
    this.ga4Tracking.sendEvent(eventname, attributes);
    if (data) {
      this.sharedDialog.openCommonDownloadModel(beatObject);
    } else {
      this.openAuthAlertModel('limitExceed');
    }
  }

  /**
   *  In this function add and
   * remove beat/sound kit from the list
   * @param beatObj
   */
  addORemoveBeatIntoFavList(beatObj: BeatListModel | SoundKitListModel) {
    let data: any =  this.browserStorageService.getSessionData();
    if (data) {
      let isFav: any = beatObj.isFav !== undefined && beatObj.isFav !== null ?  beatObj.isFav : false ;
      isFav = !isFav;
      let item_id =  beatObj._id;
      
      // Determine if it's a sound kit or beat
      const isSoundKit = this.renderType === 'soundKit';
      
      // Set event names and categories based on type
      let eventname = isFav 
        ? (isSoundKit ? 'add_liked_sound_kit' : 'add_liked_beat')
        : (isSoundKit ? 'remove_liked_sound_kit' : 'remove_liked_beat');
      
      let attributes: any = {
        category: isSoundKit ? 'SoundKits' : 'Beats',
        label: 'engagement',
        action: 'click',
        userRole: this.currentUserDetails?.role || 'guest',
        userId : this.currentUserDetails?._id || 'guest',
        itemId : beatObj._id,
        itemName : beatObj.title
      }
      this.ga4Tracking.sendEvent(eventname, attributes);
      
      // Call appropriate API based on type
     let apiCall = isSoundKit
  ? this.favoriteService.addRemoveSoundFavorite(item_id, isFav ? 'favourite' : 'remove-favourite')
  : this.favoriteService.addRemoveFavorite(item_id, isFav ? 'favorite' : 'removeFavorite');

      apiCall.subscribe((res) => {
        // Show success message
        let messageShow = isFav 
          ? `${isSoundKit ? 'Sound kit' : 'Beat'} added to your favorites`
          : `${isSoundKit ? 'Sound kit' : 'Beat'} removed from your favorites`;
        this.commonService.showToastSuccess(messageShow);
        
        // Update UI state
        if (this.currentBeatsDetails &&  this.currentBeatsDetails._id === beatObj._id) {
          this.currentBeatsDetails.isFav = isFav;
          let sendData = {
            beatId : this.currentBeatsDetails._id,
            isFav: isFav
          }
          if (!isSoundKit  && this.currentBeatsDetails?.is_ad && this.renderType !== 'artistProfile' && isFav) {
            this.compgainService.trackClick(this.currentBeatsDetails).subscribe();
            this.compgainService.trackFavClick(this.currentBeatsDetails).subscribe();
          }
          this.onchangeFavList.emit(sendData);
        } else if (isSoundKit && this.soundKitsList.length > 0) {
          let index = this.soundKitsList.findIndex((item: SoundKitListModel) => item._id === beatObj._id);
          if (index > -1) {
            this.soundKitsList[index].isFav = isFav;
            let sendData = {
              beatId : this.soundKitsList[index]._id,
              isFav: isFav
            }
            this.onchangeFavList.emit(sendData);
          }
        } else {
          let index = this.beatsList.findIndex( (item: BeatListModel) => item._id === beatObj._id)
          if (index > -1) {
            this.beatsList[index].isFav = isFav;
            let sendData = {
              beatId : this.beatsList[index]._id,
              isFav: isFav
            }
            if (!isSoundKit  && this.beatsList[index]?.is_ad && this.renderType !== 'artistProfile' && isFav) {
              this.compgainService.trackClick(this.beatsList[index]).subscribe();
              this.compgainService.trackFavClick(this.beatsList[index]).subscribe();
            }
            this.onchangeFavList.emit(sendData);
          }
        }
        },
        (error) => {
          this.commonService.showToastError(error);
        }
      );
    } else {
      this.openAuthAlertModel('limitExceed');
    }
  }

  openLyricsEditor(beatObj: BeatListModel) {
    let data: any = this.browserStorageService.getSessionData();
    if (data && data.access_token) {
      this.ga4Tracking.sendEvent('click_lyrics', {
        category: 'Beats',
        label: 'Engagement',
        action: 'click',
        userRole: this.currentUserDetails?.role || 'guest',
        userId: this.currentUserDetails?._id || 'guest',
      });
      this.sharedDialog.openLyricsEditor(beatObj);
    } else {
      this.openAuthAlertModel();
    }
  }

  openAuthAlertModel(type : string = '') {
    this.commonService.closePopUp();
    let sendData = {};
    if(type){
      sendData = {
        type:type
      }
    }
    let className = this.commonService.isMobileDisableClick ? 'ipm-mobile-non-login-alert-shared-model' : 'ipm-non-login-alert-shared-model';
    this.commonService.openModel(this.loginAlertUserPopup, sendData, className, false);
    let eventname = 'signup_singin_pop_up';
    let attributes: any = {
      category: 'Beats',
      label: 'Sig up/Sign In',
      action: 'click',
      userRole: this.currentUserDetails?.role || 'guest',
      userId : this.currentUserDetails?._id || 'guest'
    }
    this.ga4Tracking.sendEvent(eventname, attributes);
  }

  showLoginAlert(event: boolean) {
    if (event) {
      this.openAuthAlertModel();
    }
  }

  getUrlName() {
    if (this.activatedRoute.snapshot.queryParams['beats_with_exclusives']) {
      return LicenseSlug.Exclusive;
    } else if (this.activatedRoute.snapshot.queryParams['wav_stems_1999']) {
      return  LicenseSlug.WavStem;
    } else if (this.activatedRoute.snapshot.queryParams['wav_under_999']) {
      return LicenseSlug.Wav;
    } else {
      return "";
    }
  }

  openCouponPopup(beatData: BeatListModel) {
    if (beatData.available_coupons.length > 0) {
      const body = {
        filter: {
          coupon_id: beatData.available_coupons[0]
        },
        select:{
          beats:true
        }
      }
      this.couponService.getCouponList(body).subscribe((couponsList: Array<CouponListModel>) => {
        if (couponsList.length > 0) {
          let couponData = couponsList[0];
          this.selectedCoupon = couponData;
          let sendData = {
            coupon: couponData,
            discountPrice: couponData?.discount
          }
          this.appliedDialogBoxOpen(sendData, beatData)
        }
      },(error) => {
          this.commonService.showToastError(error);
        }
      );
    }
  }

  appliedDialogBoxOpen(sendData: any, beatData: BeatListModel) {
    if (sendData) {
      let data: any = {
        couponData: sendData,
        isDiwaliSale: this.commonService.isBeatOnSale(beatData)
      }
      let className = this.commonService.isMobileDisableClick ? 'ipm-mobile-view-ipm-applied-coupon' : 'ipm-applied-coupon-model';
      this.commonService.openModel(this.appliedTemplate,data,className);
      if (this.commonService.isMobileDisableClick) {
        this.commonService.bottomRef.afterDismissed().subscribe( res => {
          this.closeAppliedDialogBox(res, beatData);
        });
      } else {
        this.commonService.modelRef.afterClosed().subscribe( res => {
          this.closeAppliedDialogBox(res, beatData);
        });
      }
    }
  }

  closeAppliedDialogBox(closeData: any, beatData: BeatListModel) {
    if (closeData &&  closeData === "applied_Checkout") {
      this.addBeatIntoCart(beatData);
    }
  }


   /**
   * Add beat Into Cart Call Api
   * According to check
   * @param messageType : string
   */
   addBeatIntoCart(beatData: BeatListModel, messageType: string = '', isRedirectToCart: boolean = false) {
    // const data = {
    //   "beat_id": beatData._id,
    //   "beat_price": this.selectedLicData.priceDetails._id
    // }

    // let InsertAPiCall = this.cartService.insertCartData(data);
    // forkJoin([InsertAPiCall]).subscribe( res => {
    //   this.commonServices.closePopUp();
    //   this.cartService.getCarts().subscribe( (cartsObj: CartListModel) => {
    //     if (Object.keys(cartsObj).length) {
    //       this.commonServices.cartDataList.next(cartsObj);
    //     }
    //   });
    //   let messageShow = messageType ? "Your License has been updated." : "Beat added to your cart successfully.";
    //   this.commonServices.showToastSuccess(messageShow);
    //   if (isRedirectToCart) {
    //     this.reDirectToCart();
    //   }
    // }, (error) => {
    //   this.commonServices.showToastErrorMessage(error);
    // });
  }

  startNegotiation(currentBeatList: any) {
    if (this.currentUserDetails.name || this.currentUserDetails.role === 'producer') {
      this.openNegotiationPopup(currentBeatList);
    } else {
      this.openFullNameModel(currentBeatList);
    }
  }

  openNegotiationPopup(currentBeatList: any) {
    let sendData = {
      currentBeat: currentBeatList
    }
    let classNotifyName =  this.commonService.getClassName('ipm-negotiation-model');
    this.commonService.openModel(this.negotiationTemplate,sendData,classNotifyName,false);
    if (this.commonService.isMobileDisableClick) {
      if (this.commonService.bottomRef) {
        this.commonService.bottomRef.backdropClick().subscribe((res: any) => {
          this.onClickBackEventTrigger(currentBeatList);
        });
      }
    } else {
      if (this.commonService.modelRef) {
        this.commonService.modelRef.backdropClick().subscribe((res: any) => {
          this.onClickBackEventTrigger(currentBeatList);
        });
      }
    }
  }

  onClickBackEventTrigger($event: any) {
    if ($event &&  Object.keys($event).length > 0) {
       let  found = this.beatsList.find( item => item._id === $event.beatDetails._id)
       if (found) {
        this.priceDialog(found, 'exclusive');
       } else if (this.currentBeatsDetails) {
        this.priceDialog(this.currentBeatsDetails, 'exclusive');
       }
    }
  }

  openFullNameModel(currentBeatObj: any) {
    let sendData = {
      currentBeat: currentBeatObj
    }
    let classNotifyName =  this.commonService.getClassName('ipm-fullName-model');
    this.commonService.openModel(this.fullNameUpdateTemplate,sendData,classNotifyName,false);
    if (this.commonService.isMobileDisableClick) {
      if (this.commonService.bottomRef) {
        this.commonService.bottomRef.backdropClick().subscribe((res: any) => {
          this.onClickBackEventTrigger(currentBeatObj);
        });
      }
    } else {
      if (this.commonService.modelRef) {
        this.commonService.modelRef.backdropClick().subscribe((res: any) => {
          this.onClickBackEventTrigger(currentBeatObj);
        });
      }
    }
  }

  /**
   * Update Full Name
   */
  updateFullName(currentBeatList: any) {
    if ( currentBeatList && this.fullName &&  this.fullName.trim().length > 0 ) {
      let sendData = {
        "name": this.fullName,
        "username": this.currentUserDetails?.username,
        "email": this.currentUserDetails?.email,
        "social_link": {
          "instagram": this.currentUserDetails.social_link?.instagram,
          "youtube": this.currentUserDetails.social_link?.youtube,
          "facebook": this.currentUserDetails.social_link?.facebook,
          "spotify": {
            "link": this.currentUserDetails.social_link?.spotify?.link,
            "embaded": this.currentUserDetails.social_link?.spotify?.link
          }
        },
        "gender":this.currentUserDetails?.gender ?  'none' : this.currentUserDetails?.gender,
        "age": this.currentUserDetails?.age
      }
      this.userService.updateParticularUserData(sendData).subscribe( res => {
        this.currentUserDetails.name = this.fullName;
        this.authService.currentUserDetails.next(this.currentUserDetails);
        this.commonService.closePopUp();
        this.openNegotiationPopup(currentBeatList);
      }, (error) => {
          this.commonService.showToastError(error);
      });
    }
  }


  clickEventTrigger(beat: any) {
    if (beat?.is_ad && this.renderType !== 'artistProfile') {
      this.compgainService.trackClick(beat).subscribe();
    }
  }

  onAdImpression(beat: BeatListModel) {
    if (!beat?._id || this.impressionTracked.has(beat._id)) return;
    this.impressionTracked.add(beat._id);
    this.compgainService.trackImpression(beat).subscribe();

    const interval = setInterval(() => {
      this.compgainService.trackImpression(beat).subscribe();
    }, this.IMPRESSION_INTERVAL_MS);
    this.impressionIntervals.set(beat._id, interval);
  }

  ngOnDestroy() {
    this.impressionIntervals.forEach(interval => clearInterval(interval));
    this.impressionIntervals.clear();
  }
}
